<template>
  <div>
    <toast-notification ref="notification" />
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>

    <!-- jarallax image -->
    <!-- <div class="p-0 jarallax overlay-dark overlay-opacity-7 text-white">

      <div class="container py-7">
        <div
          class="d-middle justify-content-start col-12 col-md-6 py-7 text-center-xs"
        >
          <div class="mt-7 overflow-hidden mb-4">
            <h1 class="display-3 fw-bold mb-0">
              <svg
                width="32px"
                height="32px"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-envelope"
                viewBox="0 0 16 16"
              >
                <path
                  d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"
                ></path>
              </svg>
              تماس با ما
            </h1>

            <p class="lead"></p>
          </div>
        </div>
      </div>

      <div
        id="jarallax-container-0"
        style="
          position: absolute;
          top: 0px;
          left: 0px;
          width: 100%;
          height: 100%;
          overflow: hidden;
          z-index: -100;
        "
      >
        <img
          class="jarallax-img"
          src="../assets/images/siteImages/nicolas-ramirez-b-9fXiJOooY-unsplash.jpg"
          alt="..."
          style="
            object-fit: cover;
            object-position: 50% 50%;
            max-width: none;
            position: fixed;
            top: 0px;
            left: 0px;
            width: 1603px;
            height: 566.398px;
            overflow: hidden;
            pointer-events: none;
            transform-style: preserve-3d;
            backface-visibility: hidden;
            will-change: transform, opacity;
            margin-top: -60.1992px;
            transform: translate3d(0px, -139.801px, 0px);
          "
        /> 
      </div>
    </div> -->

    <div class="container mt-4" id="container">
      <div class="row aos-init" data-aos="fade-up" data-aos-delay="300">
        <h2 class="fw-bold" v-if="!isMobile">
          <svg
            width="26px"
            height="26px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-envelope"
            viewBox="0 0 16 16"
          >
            <path
              d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"
            ></path>
          </svg>
          با ما در ارتباط باشید
        </h2>
        <!-- <div class="small">
          با ارسال نظرات و پیشنهادات خود، ما را در ارتقاء کیفیت خدمات یاری
          نمایید
        </div>

        <div class="col-12 col-lg-8 mb-3">
          <validation-summery
            v-if="formHasError"
            :errors="formError"
          ></validation-summery>
          <div class="bg-mainPanel p-4 p-lg-5 rounded">
            <div class="form-floating mb-3">
              <floating-input-with-message
                containerClass="mb-3"
                inputType="text"
                ref="nameInput"
                inputPlaceHolder="Username"
                v-model:inputValue="entity.name"
                labelClass="text-muted small"
                labelValue="نام"
                errorMessage="وارد کردن نام الزامی است"
                erroMessageClass="smaller text-danger"
              />
            </div>
            <div class="form-floating mb-3">
              <floating-input-with-message
                containerClass="mb-3"
                inputType="text"
                ref="emailInput"
                inputPlaceHolder="Username"
                v-model:inputValue="entity.email"
                labelClass="text-muted small"
                labelValue="ایمیل"
                errorMessage="ایمیل را به درستی وارد نمایید"
                erroMessageClass="smaller text-danger"
              />
            </div>
            <div class="form-floating mb-3">
              <floating-input-with-message
                containerClass="mb-3"
                inputType="text"
                ref="phoneInput"
                inputPlaceHolder="Username"
                v-model:inputValue="entity.phone"
                labelClass="text-muted small"
                labelValue="همراه"
                errorMessage="شماره همراه را به درستی وارد نمایید "
                erroMessageClass="smaller text-danger"
              />
            </div>
            <div class="form-floating mb-3">
              <floating-input-with-message
                containerClass="mb-3"
                inputType="text"
                ref="subjectInput"
                inputPlaceHolder="Username"
                v-model:inputValue="entity.subject"
                labelClass="text-muted small"
                labelValue="موضوع"
                errorMessage="وارد کردن موضوع الزامی است"
                erroMessageClass="smaller text-danger"
              />
            </div>
            <div class="form-floating mb-3">
              <textarea
                id="descriptionInput"
                ref="descriptionInput"
                name="contact_message"
                class="form-control"
                :class="{ isNotValid: !validatedMessage }"
                rows="3"
                style="min-height: 120px"
                @input="messsageInput"
                v-model="entity.message"
                maxlength="500"
              ></textarea>
              <label class="text-muted small" for="descriptionInput"
                >پیام</label
              >
              <div>
                <span class="smaller text-gray-600"
                  >تعداد {{ remainChar }} کارکتر باقی مانده است</span
                >
              </div>
              <div>
                <span v-if="!validatedMessage" class="smaller text-danger"
                  >وارد کردن متن پیام الزامی است</span
                >
              </div>
            </div>

            <div class="mb-3">
              <div class="input-group">
                <span class="input-group-addon"
                  ><i class="fa fa-paperclip"></i></span
                ><input
                  class="form-control form-control-sm custom-file-upload custom-file-upload-hidden"
                  data-btn-text="انتخاب"
                  id="formFile"
                  name="formFile"
                  type="file"
                  @input="fileReceiptInput"
                  value=""
                  tabindex="-1"
                  style="position: absolute"
                /><input
                  type="text"
                  id="inputFileName"
                  ref="inputFileName"
                  disabled
                  class="form-control form-control-sm file-upload-input text-left"
                /><span class="me-1 input-group-btn" tabindex="-1">
                  <button class="btn btn-sm btn-light ps-2" id="btnUpload">
                    <i class="fi fi-attachment"></i>
                  </button>
                </span>
              </div>

              <span
                class="field-validation-valid text-danger"
                data-valmsg-for="Attachment"
                data-valmsg-replace="true"
              ></span>
            </div>
            <div class="text-center">
              <button
                class="btn btn-sm rounded btn-blueSite w-100"
                @click="sendMessage"
              >
                <svg
                  width="18px"
                  height="18px"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi bi-send-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154l.215.338 7.494-7.494Z"
                  ></path>
                </svg>
                ارسال
              </button>
            </div>
          </div>
        </div> -->
        <div class="col-12 mt-3">
          <div class="pt-2 pt-lg-0" style="top: 120px">
            <div
              class="mx-3 mb-3 position-relative z-index-1 aos-init aos-animate"
              data-aos="fade-in"
              data-aos-delay="300"
            >
              <div
                class="bg-mainPanel rounded-xl pe-2"
                :class="isMobile ? 'p-1' : 'p-4'"
              >
                <!-- mobile : top arrow : documentation/util-misc.html -->
                <div class="row" :class="isMobile ? 'py-3 pe-2' : 'px-2 pt-5'">
                  <div class="col-md-6">
                    <div class="">
                      <h2 :class="isMobile ? 'fs-8 fw-bold' : 'h5'">
                        <!-- <i
                          class="fi fi-pin text-gray-500 float-start fs-5"
                          :class="isMobile ? 'mt_5' : ''"
                        ></i> -->
                        آدرس پستی دفتر مرکزی کلینیک‌ ارگانیک‌ مایندد
                      </h2>
                    </div>
                    <div>
                      <ul class="list-unstyled me-5 fs-8">
                        <li class="list-item text-muted">
                          تهران، بلوار آفریقا (جردن)،
                        </li>
                        <li class="list-item text-muted">
                          خیابان تور، پلاک ۴۶
                        </li>
                        <li class="list-item text-muted">طبقه سوم، واحد ۱۲،</li>
                        <li class="list-item text-muted">کدپستی: 1915653936</li>
                      </ul>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div>
                      <h3 :class="isMobile ? 'fs-8 fw-bold' : 'h5'">
                        <!-- <i
                          class="fi fi-phone text-gray-500 float-start fs-5"
                          :class="isMobile ? 'mt_5' : ''"
                        ></i> -->
                        شماره‌های تماس (از ساعت ۹ صبح تا ۹ شب)
                      </h3>
                    </div>
                    <div>
                      <ul class="list-unstyled me-5 fs-8">
                        <li class="list-item mb-2 text-gray-500">
                          <a href="tel:۰۲۱-۹۱۰۰۵۱۴۱" class="link-muted"
                            >۰۲۱-۹۱۰۰۵۱۴۱</a
                          >
                        </li>
                        <!-- <li class="list-item mb-2 text-gray-500">
                          <a href="tel:۰۲۱-۹۱۰۰۵۱۴۴" class="link-muted"
                            >۰۲۱-۹۱۰۰۵۱۴۴</a
                          >
                        </li> -->
                      </ul>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div>
                      <h3 :class="isMobile ? 'fs-8 fw-bold' : 'h5'">
                        <!-- <i
                          class="fi fi-envelope text-gray-500 float-start fs-5"
                          :class="isMobile ? 'mt_5' : ''"
                        ></i> -->
                        ایمیل جهت ارسال رزومه (ویژه همکاران)
                      </h3>
                    </div>
                    <div>
                      <ul class="list-unstyled me-5 fs-8">
                        <li class="list-item mb-2 text-gray-500">
                          <a
                            href="mail:request@organicminded.org"
                            class="link-muted"
                            >request@organicminded.org</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div>
                      <h3 :class="isMobile ? 'fs-8 fw-bold' : 'h5'">
                        <!-- <i
                          class="fi fi-envelope-2 text-gray-500 float-start fs-5"
                          :class="isMobile ? 'mt_5' : ''"
                        ></i> -->
                        ایمیل جهت ارتباط با مدیر فنی کلینیک (ویژه مراجعین)
                      </h3>
                    </div>
                    <div>
                      <ul class="list-unstyled me-5 fs-8">
                        <li class="list-item mb-2 text-gray-500">
                          <a
                            href="mail:support@organicminded.org"
                            class="link-muted"
                            >support@organicminded.org</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- <div class="mt-4">
                  <div class="">
                    <h3 :class="isMobile ? 'h6' : 'h5'">
                      <i class="fi fi-pin text-gray-500 float-start fs-2"></i>
                      موقعیت مکانی
                    </h3>
                  </div>

                  <div>
                    <div>
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d809.252487478917!2d51.423856846795296!3d35.77513193546988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e07bcd893fb85%3A0xfcbf00d40e5067ef!2z2K_aqdiq2LEg2obYp9mI2LTbjCDYqtmI2LE!5e0!3m2!1sen!2sus!4v1701095942718!5m2!1sen!2sus"
                        width="100%"
                        height="250"
                        style="border: 0"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                        class="border shadow"
                      ></iframe>
                    </div>
                  </div>
                </div> -->
                </div>
                <div class="d-flex mt-4 justify-content-center">
                  <a
                    href="https://www.instagram.com/dr.behzad.chavooshi"
                    class="btn btn-sm text-white transition-hover-top mb-2 rounded-circle bg-gray-700"
                    rel="noopener"
                    target="_blank"
                    aria-label="instagram page"
                    title="Instagram"
                    ><i class="fi fi-social-instagram"></i
                  ></a>
                  <a
                    href="https://www.linkedin.com/in/behzad-chavooshi-4b1436173"
                    class="btn btn-sm text-white transition-hover-top mb-2 rounded-circle bg-gray-700"
                    rel="noopener"
                    target="_blank"
                    aria-label="linkedin page"
                    title="Linkedin"
                    ><i class="fi fi-social-linkedin"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import FloatingInputWithMessage from '../components/form/floatingInputWithMessage/FloatingInputWithMessage.vue';
import LoadingSpinner from '../components/utility/loadingSpinner/LoadingSpinner.vue';
import { isMobile } from 'mobile-device-detect';
// import ValidationSummery from '../components/form/errorBox/ValidationSummery.vue';

// import axios from 'axios';

export default {
  components: {
    LoadingSpinner,
    // FloatingInputWithMessage,
    // ValidationSummery,
  },

  data() {
    return {
      isMobile: isMobile,
      // frFile: '',
      // remainChar: 500,
      // validatedMessage: true,
      // formHasError: false,
      // formError: [],
      // entity: {
      //   personID: null,
      //   name: '',
      //   phone: '',
      //   email: '',
      //   subject: '',
      //   message: '',
      //   // fileName: null,
      // },
    };
  },
  methods: {
    // validatePhone(phone) {
    //   // eslint-disable-next-line
    //   return /^09\d{9}$/.test(phone);
    // },
    // validateEmail(email) {
    //   // eslint-disable-next-line
    //   return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    // },
    // messsageInput() {
    //   this.remainChar = 500 - (this.entity.message?.length ?? 0);
    // },
    // validate() {
    //   if (!this.entity.name) {
    //     this.$refs.nameInput.showErrorMessage();
    //     this.$refs.nameInput.setFocus();
    //     return false;
    //   }
    //   if (!this.entity.subject) {
    //     this.$refs.subjectInput.showErrorMessage();
    //     this.$refs.subjectInput.setFocus();
    //     return false;
    //   }
    //   if (!this.entity.message) {
    //     this.validatedMessage = false;
    //     this.$refs.descriptionInput.focus();
    //     return false;
    //   } else {
    //     this.validatedMessage = true;
    //   }
    //   if (this.entity.phone && !this.validatePhone(this.entity.phone)) {
    //     this.$refs.phoneInput.showErrorMessage();
    //     this.$refs.phoneInput.setFocus();
    //     return false;
    //   }
    //   if (this.entity.email && !this.validateEmail(this.entity.email)) {
    //     this.$refs.emailInput.showErrorMessage();
    //     this.$refs.emailInput.setFocus();
    //     return false;
    //   }
    //   return true;
    // },
    // getPersonID() {
    //   return this.$store.getters.userPersonID;
    // },
    // resetEntity() {
    //   this.formHasError = false;
    //   this.formError = [];
    //   this.frFile = '';
    //   this.$refs.inputFileName.value = null;
    //   this.entity = new Object({
    //     personID: null,
    //     name: '',
    //     phone: '',
    //     email: '',
    //     subject: '',
    //     message: '',
    //     // fileName: null,
    //   });
    // },
    // async sendMessage() {
    //   if (!this.validate()) {
    //     return;
    //   }
    //   let that = this;
    //   that.$refs.spinner.show();
    //   that.entity.personID = this.getPersonID();
    //   let formData = new FormData();
    //   for (var key in this.entity) {
    //     formData.append(
    //       key,
    //       this.entity[key] != null ? this.entity[key] : null
    //     );
    //   }
    //   formData.append('File', this.frFile);
    //   await axios
    //     .post('/ST/ContactUs/CreateMessage', formData)
    //     .then((response) => {
    //       if (!response?.data?.success) {
    //         let errorMessages = response.data.errors.map((i) => i.errorMessage);
    //         // errorMessages.forEach((item) => {
    //         //   that.$refs.notification.show({
    //         //     type: 'error',
    //         //     title: item,
    //         //   });
    //         // });
    //         that.formHasError = true;
    //         that.formError = errorMessages;
    //         return;
    //       }
    //       if (response?.data?.success) {
    //         that.$refs.notification.show({
    //           type: 'success',
    //           title: 'پیام با موفقیت ثبت شد',
    //         });
    //         this.resetEntity();
    //       }
    //     })
    //     .catch(() => {
    //       that.$refs.notification.show({
    //         type: 'error',
    //         title: `ثبت اطلاعات با خطا مواجه گردید.`,
    //       });
    //     })
    //     .finally(() => {
    //       that.$refs.spinner.hide();
    //     });
    // },
    // async fileReceiptInput(e) {
    //   if (e.target.files.length == 0) {
    //     return;
    //   }
    //   //   this.entity.fileName = e.target.files[0].name;
    //   this.$refs.inputFileName.value = e.target.files[0].name;
    //   this.frFile = e.target.files[0];
    // },
  },
  async mounted() {
    // let that = this;
    // document.getElementById('btnUpload').addEventListener('click', function () {
    //   document.getElementById('formFile').click();
    // });
    // document.getElementById('formFile').oninput = ((e) => {}).bind(this);
  },
};
</script>
<style scoped>
/* .border-light {
  --bs-border-opacity: 1;
  border-color: #f3f3f3 !important;
} */
.arrow-lg.arrow-start {
  border-left: 20px solid #f3f3f3 !important;
}
.arrow-lg.arrow-top {
  border-bottom: 20px solid #f3f3f3 !important;
}
.form-control:disabled {
  background-color: #fff !important;
}
@media screen and (min-width: 767px) {
  #container {
    margin-bottom: 25vh !important;
  }
}
@media screen and (max-width: 766px) {
  #container {
    margin-bottom: 17vh !important;
  }
}
.mt_5 {
  margin-top: -5px !important ;
}
</style>
<style></style>
